import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';
import type { InteractionState } from '../types.js';

export function reduceResetInteractions<T extends InteractionState>(
  isZoomOutEnabled: boolean,
  position?: RelativeAbsolutePosition,
) {
  return (prev: T): T => ({
    ...prev,
    highlightedSeriesIds: undefined,
    explore: {
      position,
      visible: position !== undefined,
      pinned: false,
    },
    select: undefined,
    currentDomain: undefined,
    zoom: {
      zoomInEnabled: true,
      zoomOutEnabled: isZoomOutEnabled,
    },
  });
}

export function reduceResetZoom<T extends InteractionState>(prev: T): T {
  return {
    ...prev,
    currentDomain: undefined,
    highlightedSeriesIds: prev.explore.pinned
      ? undefined
      : prev.highlightedSeriesIds,
    zoom: {
      zoomOutEnabled: false,
      zoomInEnabled: true,
    },
  };
}

export function reduceResetToInfiniteZoom<T extends InteractionState>(
  prev: T,
): T {
  return {
    ...prev,
    currentDomain: undefined,
    highlightedSeriesIds: undefined,
    zoom: {
      zoomOutEnabled: true,
      zoomInEnabled: true,
    },
  };
}

export function reduceResetExploreVisible<T extends InteractionState>(
  prev: T,
): T {
  return {
    ...prev,
    explore: {
      ...prev.explore,
      visible: false,
    },
  };
}
